import { format, formatDuration as formatDurationDateFns } from 'date-fns';

const formatDate = (date: string | Date, shortMonth?: boolean, includeTime?: boolean) => {
  try {
    const dateString = typeof date === 'string' ? new Date(date) : date;
    const monthFormat = shortMonth ? 'MMM' : 'MMMM';
    const timeFormat = includeTime ? ' HH:mm' : '';
    return format(dateString, `dd ${monthFormat} yyyy${timeFormat}`);
  } catch (error) {
    return '';
  }
};

const formatDateXAgo = (date: string | Date): string => {
  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    const now = new Date();
    const diffMs = now.getTime() - dateObj.getTime();

    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (seconds < 60) {
      return 'just now';
    } else if (minutes < 60) {
      return `${minutes} minute${minutes === 1 ? '' : 's'} ago`;
    } else if (hours < 24) {
      return `${hours} hour${hours === 1 ? '' : 's'} ago`;
    } else if (days < 7) {
      return `${days} day${days === 1 ? '' : 's'} ago`;
    } else if (weeks < 4) {
      return `${weeks} week${weeks === 1 ? '' : 's'} ago`;
    } else if (months < 12) {
      return `${months} month${months === 1 ? '' : 's'} ago`;
    } else {
      return `${years} year${years === 1 ? '' : 's'} ago`;
    }
  } catch (error) {
    return '';
  }
};

/**
 * Format a duration (in milliseconds) as a human-readable string in days,
 * hours and minutes, e.g. "2 hours 15 minutes", "45 minutes", "1 day 3 hours".
 * Durations under a minute (or negative) are reported as "less than a minute".
 */
const formatDuration = (durationMs: number): string => {
  if (durationMs < 60000) {
    return 'less than a minute';
  }
  const totalMinutes = Math.floor(durationMs / 60000);
  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor(totalMinutes / 60) % 24;
  const minutes = totalMinutes % 60;
  return formatDurationDateFns({ days, hours, minutes }, { format: ['days', 'hours', 'minutes'] });
};

/** Convert a Date to the value format expected by <input type="datetime-local">. */
const dateToDatetimeLocal = (d: Date): string => {
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, -1);
};

export default formatDate;
export { formatDateXAgo, dateToDatetimeLocal, formatDuration };
